<template>
  <div class="home">
    <header-com></header-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">通知管理</h3>
        <div class="wrap">
          <el-form :inline="true" :model="formInline" size="small">
            <el-form-item>
              <el-input v-model="formInline.name" placeholder="操作人" clearable></el-input>
            </el-form-item>
            <el-form-item class="date" style="width: 400px">
              <el-date-picker
                v-model="formInline.formTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="起始时间"
                end-placeholder="终止时间"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small">搜索</el-button>
              <el-button type="primary" size="small">导出日志</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
            <el-table-column prop="name" label="操作账号" min-width="120"></el-table-column>
            <el-table-column prop="city" label="操作人" min-width="100"></el-table-column>
            <el-table-column prop="3" label="功能模块" min-width="100"></el-table-column>
            <el-table-column prop="3" label="操作类型" min-width="100"></el-table-column>
            <el-table-column prop="3" label="操作内容" min-width="100"></el-table-column>
            <el-table-column prop="3" label="操作时间" min-width="100"></el-table-column>
            <el-table-column prop="3" label="操作人IP" min-width="100"></el-table-column>
            <el-table-column prop="3" label="操作人IP归属地" min-width="100"></el-table-column>
          </el-table>
          <el-pagination
            background
            :page-size="pageSize"
            :total="totalCount"
            :page-count="totalPage"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="prevPage"
            @next-click="nextPage"
            layout="total, sizes,prev, pager, next,  jumper"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderCom from "../components/Header.vue";
export default {
  name: "log",
  data() {
    return {
      pageSize: 10, // 每页显示个数
      totalPage: 10, // 总页数
      totalCount: 20, // 总条目数
      currentPage: 1, // 当前页
      formInline: {
        name: "",
        formTime: ""
      },
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        }
      ]
    };
  },
  components: {
    HeaderCom
  },
  methods: {
    // 每页数
    handleSizeChange(val) {
      console.log(val);
    },
    // 当前页
    handleCurrentChange(val) {
      console.log(val);
    },
    // 上一页
    prevPage() {
      // console.log('上一页');
    },
    // 下一页
    nextPage() {
      // console.log('下一页');
    },
    // 批量打印培训证明
    batchPrint() {
      this.$confirm("确认打印培训证明吗?", "批量打印培训证明", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "打印成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消打印"
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-table {
  max-height: 630px;
  overflow: auto;
}
.cont {
  margin-top: 30px;
  .wrap {
    padding: 20px;
  }
  .title {
    font-size: 18px;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
}
</style>
